"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = void 0;
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var constant_1 = require("../../../constant");
var variables_1 = require("../../../style/variables");
var Blue = style_1.SixsenseColor.Blue, Gray = style_1.SixsenseColor.Gray, White = style_1.SixsenseColor.White;
var defaultButtonThemeConfig = {
    base: {
        default: {
            position: 'relative',
            textAlign: 'center',
            display: 'inline-block',
            borderWidth: 1,
            borderStyle: 'solid',
            outline: 'none',
            cursor: 'pointer',
            borderRadius: 2,
        },
        disabled: {
            cursor: 'not-allowed',
        },
    },
    options: {
        block: {
            display: 'block',
            width: '100$',
        },
    },
    size: function () { return ({
        small: {
            font: '12px',
            padding: '0 12px',
            height: '28px',
            spinner: 12,
        },
        default: {
            font: '14px',
            padding: '0 15px',
            height: '36px',
            spinner: 16,
        },
        large: {
            font: '14px',
            padding: '0 18px',
            height: '42px',
            spinner: 20,
        },
    }); },
    variant: {
        primary: {
            default: {
                borderColor: Blue.DEFAULT,
                background: Blue.DEFAULT,
                color: White.DEFAULT,
            },
            hovered: {
                borderColor: Blue.LIGHT_1,
                background: Blue.LIGHT_1,
                color: White.DEFAULT,
            },
            disabled: {
                borderColor: Gray.LIGHT_4,
                background: Gray.LIGHT_5,
                color: Gray.LIGHT_3,
            },
        },
        secondary: {
            default: {
                borderColor: Gray.LIGHT_2,
                background: White.DEFAULT,
                color: Gray.DARK_2,
                spinner: Blue.DEFAULT,
            },
            hovered: {
                borderColor: Blue.DEFAULT,
                background: White.DEFAULT,
                color: Blue.DEFAULT,
                spinner: Blue.DEFAULT,
            },
            disabled: {
                borderColor: Gray.LIGHT_4,
                background: White.DEFAULT,
                color: Gray.LIGHT_3,
            },
        },
        tertiary: {
            default: {
                borderColor: 'transparent',
                background: 'transparent',
                color: Gray.DARK_2,
            },
            hovered: {
                borderColor: Gray.LIGHT_5,
                background: Gray.LIGHT_5,
                color: Gray.DARK_5,
            },
            disabled: {
                borderColor: 'transparent',
                background: 'transparent',
                color: Gray.LIGHT_3,
            },
        },
        dark: {
            default: {
                borderColor: Gray.DARK_3,
                background: Gray.DARK_3,
                color: White.DEFAULT,
            },
            hovered: {
                borderColor: Gray.DARK_2,
                background: Gray.DARK_2,
                color: White.DEFAULT,
            },
            disabled: {
                borderColor: Gray.LIGHT_4,
                background: Gray.LIGHT_5,
                color: Gray.LIGHT_2,
            },
        },
    },
};
var designSystemButtonThemeConfig = {
    base: {
        default: {
            position: 'relative',
            textAlign: 'center',
            display: 'inline-block',
            borderWidth: 1,
            borderStyle: 'solid',
            outline: 'none',
            cursor: 'pointer',
            transition: 'box-shadow 0.2s ease',
            ':focus': {
                zIndex: 2,
            },
        },
        disabled: {
            cursor: 'not-allowed',
        },
    },
    destructiveVariant: {
        primary: {
            default: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.DSTR_PRIMARY_DEFAULT + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.DSTR_PRIMARY_DEFAULT + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.DSTR_PRIMARY_DEFAULT + ")",
            },
            hovered: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.DSTR_PRIMARY_HOVER + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.DSTR_PRIMARY_HOVER + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.DSTR_PRIMARY_HOVER + ")",
            },
            focused: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.DSTR_PRIMARY_FOCUS + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.DSTR_PRIMARY_FOCUS + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.DSTR_PRIMARY_FOCUS + ")",
                boxShadow: "var(" + variables_1.Focus.ERROR_LIGHT + ")",
            },
            disabled: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.DSTR_PRIMARY_DISABLED + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.DSTR_PRIMARY_DISABLED + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.DSTR_PRIMARY_DISABLED + ")",
            },
        },
        secondary: {
            default: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.DSTR_SECONDARY_DEFAULT + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.DSTR_SECONDARY_DEFAULT + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.DSTR_SECONDARY_DEFAULT + ")",
            },
            hovered: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.DSTR_SECONDARY_HOVER + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.DSTR_SECONDARY_HOVER + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.DSTR_SECONDARY_HOVER + ")",
            },
            focused: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.DSTR_SECONDARY_FOCUS + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.DSTR_SECONDARY_FOCUS + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.DSTR_SECONDARY_FOCUS + ")",
                boxShadow: "var(" + variables_1.Focus.ERROR_LIGHT + ")",
            },
            disabled: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.DSTR_SECONDARY_DISABLED + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.DSTR_SECONDARY_DISABLED + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.DSTR_SECONDARY_DISABLED + ")",
            },
        },
        tertiary: {
            default: {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                color: "var(" + variables_1.ThemeColor.Error.DARK_2 + ")",
            },
            hovered: {
                backgroundColor: "var(" + variables_1.ThemeColor.Error.LIGHT_5 + ")",
                color: "var(" + variables_1.ThemeColor.Error.DARK_3 + ")",
            },
            focused: {
                color: "var(" + variables_1.ThemeColor.Error.DARK_2 + ")",
                boxShadow: "var(" + variables_1.Focus.ERROR_LIGHT + ")",
            },
            disabled: {
                color: "var(" + variables_1.ThemeColor.Error.LIGHT_2 + ")",
            },
        },
        'link-primary': {
            default: {
                color: "var(" + variables_1.ThemeColor.Error.DARK_2 + ")",
            },
            hovered: {
                color: "var(" + variables_1.ThemeColor.Error.DARK_3 + ")",
            },
            focused: {
                color: "var(" + variables_1.ThemeColor.Error.DARK_2 + ")",
            },
            disabled: {
                color: "var(" + variables_1.ThemeColor.Error.LIGHT_2 + ")",
            },
        },
        'link-secondary': {
            default: {
                color: "var(" + variables_1.ThemeColor.Error.DARK_2 + ")",
            },
            hovered: {
                color: "var(" + variables_1.ThemeColor.Error.DARK_3 + ")",
            },
            focused: {
                color: "var(" + variables_1.ThemeColor.Error.DARK_2 + ")",
            },
            disabled: {
                color: "var(" + variables_1.ThemeColor.Error.LIGHT_2 + ")",
            },
        },
    },
    options: {
        block: {
            display: 'block',
            width: '100%',
        },
    },
    size: function (iconOnly) { return ({
        small: {
            height: 28,
            minHeight: 28,
            maxHeight: 28,
            fontSize: 12,
            padding: "0 " + (iconOnly ? 5 : 7) + "px",
            borderRadius: 4,
        },
        default: {
            height: 36,
            minHeight: 36,
            maxHeight: 36,
            fontSize: 14,
            padding: "0 " + (iconOnly ? 9 : 13) + "px",
            borderRadius: 6,
        },
        large: {
            height: 44,
            minHeight: 44,
            maxHeight: 44,
            fontSize: 16,
            padding: "0 " + (iconOnly ? 11 : 15) + "px",
            borderRadius: 6,
        },
    }); },
    variant: {
        primary: {
            default: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.PRIMARY_DEFAULT + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.PRIMARY_DEFAULT + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.PRIMARY_DEFAULT + ")",
            },
            hovered: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.PRIMARY_HOVER + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.PRIMARY_HOVER + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.PRIMARY_HOVER + ")",
            },
            focused: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.PRIMARY_FOCUS + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.PRIMARY_FOCUS + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.PRIMARY_FOCUS + ")",
                boxShadow: "var(" + variables_1.Focus.PRIMARY_LIGHT + ")",
            },
            disabled: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.PRIMARY_DISABLED + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.PRIMARY_DISABLED + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.PRIMARY_DISABLED + ")",
            },
        },
        secondary: {
            default: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.SECONDARY_DEFAULT + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.SECONDARY_DEFAULT + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.SECONDARY_DEFAULT + ")",
            },
            hovered: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.SECONDARY_HOVER + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.SECONDARY_HOVER + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.SECONDARY_HOVER + ")",
            },
            focused: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.SECONDARY_FOCUS + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.SECONDARY_FOCUS + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.SECONDARY_FOCUS + ")",
                boxShadow: "var(" + variables_1.Focus.GRAY_LIGHT + ")",
            },
            disabled: {
                backgroundColor: "var(" + variables_1.ComponentColor.Button.Background.SECONDARY_DISABLED + ")",
                borderColor: "var(" + variables_1.ComponentColor.Button.Border.SECONDARY_DISABLED + ")",
                color: "var(" + variables_1.ComponentColor.Button.Text.SECONDARY_DISABLED + ")",
            },
        },
        tertiary: {
            default: {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
            },
            hovered: {
                backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
                color: "var(" + variables_1.RootColor.Gray.DARK_3 + ")",
            },
            focused: {
                color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
                boxShadow: "var(" + variables_1.Focus.GRAY_LIGHT + ")",
            },
            disabled: {
                color: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
            },
        },
        'link-primary': {
            default: {
                padding: 0,
                height: 'fit-content',
                minHeight: 'initial',
                maxHeight: 'initial',
                border: 'none',
                background: 'transparent',
                color: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
            },
            hovered: {
                color: "var(" + variables_1.ThemeColor.Primary.DARK_3 + ")",
            },
            focused: {
                color: "var(" + variables_1.ThemeColor.Primary.DARK_2 + ")",
            },
            disabled: {
                color: "var(" + variables_1.TextColor.DISABLED + ")",
            },
        },
        'link-secondary': {
            default: {
                padding: 0,
                height: 'fit-content',
                minHeight: 'initial',
                maxHeight: 'initial',
                border: 'none',
                background: 'transparent',
                color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")",
            },
            hovered: {
                color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
            },
            focused: {
                color: "var(" + variables_1.RootColor.Gray.DARK_1 + ")",
            },
            disabled: {
                color: "var(" + variables_1.TextColor.DISABLED + ")",
            },
        },
    },
};
var getStyles = function (themeName, variant, size, block, destructive, iconOnly, loading) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (themeName === void 0) { themeName = ''; }
    if (block === void 0) { block = false; }
    if (destructive === void 0) { destructive = false; }
    if (iconOnly === void 0) { iconOnly = false; }
    if (loading === void 0) { loading = false; }
    var themeConfig = themeName === constant_1.DESIGN_SYSTEM ? designSystemButtonThemeConfig : defaultButtonThemeConfig;
    return react_1.css(__assign(__assign(__assign(__assign(__assign(__assign({}, themeConfig.base.default), themeConfig.size(iconOnly)[size]), (_a = themeConfig.variant[variant]) === null || _a === void 0 ? void 0 : _a.default), (block ? (_b = themeConfig.options) === null || _b === void 0 ? void 0 : _b.block : {})), (destructive ? (_d = (_c = themeConfig.destructiveVariant) === null || _c === void 0 ? void 0 : _c[variant]) === null || _d === void 0 ? void 0 : _d.default : {})), { ':focus-visible:enabled': __assign(__assign(__assign({}, themeConfig.base.focused), (_e = themeConfig.variant[variant]) === null || _e === void 0 ? void 0 : _e.focused), (destructive ? (_g = (_f = themeConfig.destructiveVariant) === null || _f === void 0 ? void 0 : _f[variant]) === null || _g === void 0 ? void 0 : _g.focused : {})), ':active:enabled': __assign(__assign(__assign({}, themeConfig.base.focused), (_h = themeConfig.variant[variant]) === null || _h === void 0 ? void 0 : _h.focused), (destructive ? (_k = (_j = themeConfig.destructiveVariant) === null || _j === void 0 ? void 0 : _j[variant]) === null || _k === void 0 ? void 0 : _k.focused : {})), ':hover:enabled': !loading ? __assign(__assign(__assign({}, themeConfig.base.hovered), (_l = themeConfig.variant[variant]) === null || _l === void 0 ? void 0 : _l.hovered), (destructive ? (_o = (_m = themeConfig.destructiveVariant) === null || _m === void 0 ? void 0 : _m[variant]) === null || _o === void 0 ? void 0 : _o.hovered : {})) : {}, ':disabled': __assign(__assign(__assign({}, themeConfig.base.disabled), (_p = themeConfig.variant[variant]) === null || _p === void 0 ? void 0 : _p.disabled), (destructive ? (_r = (_q = themeConfig.destructiveVariant) === null || _q === void 0 ? void 0 : _q[variant]) === null || _r === void 0 ? void 0 : _r.disabled : {})) }));
};
exports.getStyles = getStyles;
